import React from 'react'

export default function ArrowNextIcon({ className = '' }) {
  return (
    <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 6L18 12M18 12L12 18M18 12H6" stroke="currentColor"/>
</svg>

  )
}
